import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';

import CloseIcon from '../CloseIcon';
import { THIRD_COLOR } from '../../config/colors';
import { LargeHeaderTitle, TextDiv } from '../../modals';
import PropTypes from 'prop-types';

import './style.css'

const styles = {
  text: { margin: '20px 0', textAlign:'center'},
  closeIconStyle: { height:'35px', width:'35px', color: THIRD_COLOR },
  closeIconWrap: { "position":"absolute","right":"0","margin":"-25px 10px" },
};
class OrderCompleteModal extends Component {
  isOpenOrderClicked = false;

  onCloseRequest = () => {
      this.props.hideModal();
      if (!this.isOpenOrderClicked)
        this.props.openMainPage();
  }

  handleOpenOrder = () => {
    this.isOpenOrderClicked = true;
    this.props.openOrderHistory();
  };

  render() {
    return (
      <Modal overlayTop={0} closeOnOutsideClick={true} isOpened={true} onClose={this.onCloseRequest}>
        <div style={{margin: '20px 0'}}>
            <div onClick={this.onCloseRequest} style={styles.closeIconWrap}><CloseIcon style={styles.closeIconStyle} /></div>
            <div className="order-complete">
              <LargeHeaderTitle color={this.props.secondaryColor}>YOUR ORDER IS COMPLETE</LargeHeaderTitle>
              <TextDiv><div className="order-complete-message">{this.props.eta}</div></TextDiv>
              <div onClick={this.handleOpenOrder} className="order-status-link">
                <TextDiv color={this.props.secondaryColor}>Check order status </TextDiv>
              </div>
            </div>
        </div>
       </Modal>
    );
  }
}

OrderCompleteModal.propTypes = {
  secondaryColor: PropTypes.string,
};
const mapStateToProps = (state) => {
  return {
    heldOrder: state.config.HELD_ORDER,
    openTime: state.config.OPEN_TIME,
    closeTime: state.config.CLOSE_TIME,
  };
};

export default connect(mapStateToProps, null)(OrderCompleteModal);



// WEBPACK FOOTER //
// ./src/components/OrderCompleteModal/OrderCompleteModal.jsx